import { defineComponent as _defineComponent } from 'vue'
import { IFile } from "@/domain/entities/bbs/qnaDetail.types";
import { useFileStore } from "@/stores/fileStore";
import { PROVIDE_KEY_SHOW_ERROR_MODAL, ShowErrorModal } from "@/types";
import isValidImage from "@/utils/isValidImage";
import { ref, PropType, onMounted, inject } from "vue";


const __default__ = {
  name: "FileInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  fileInputUid: {
    type: String,
    required: true,
  },
  name: {
    type: String,
  },
  placeHolder: {
    type: String,
    default: "파일 선택",
  },
  accept: {
    type: String,
    default: "image/*",
  },
  maxFiles: {
    type: Number,
    default: 1,
  },
  fileInfos: {
    type: Array as PropType<IFile[]>,
  },
  editMode: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onAddedFiles", "onDeletedFile"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const fileStore = useFileStore();

const fileInput = ref<HTMLInputElement>();
const inputFileList = ref<File[]>([]);
const thumbnailUrlList = ref<string[]>([]);

// 동일한 파일을 다시 추가할 수 있도록 리셋
const resetFileInput = () => {
  if (!fileInput.value) return;

  fileInput.value.type = "";
  fileInput.value.type = "file";
};

const onAddedFiles = () => {
  if (!fileInput.value?.files?.length) return;

  const newFiles = Array.from(fileInput.value.files);
  if (!isValidInputFiles(newFiles)) {
    fileInput.value.value = "";
    resetFileInput();
    showErrorModal(
      "파일 첨부 실패",
      "이미지 파일만 첨부 가능합니다.<br/>다시 시도해주세요."
    );
    return;
  }

  inputFileList.value = [...inputFileList.value, ...newFiles].slice(
    0,
    props.maxFiles
  );
  emit("onAddedFiles", inputFileList.value, props.fileInputUid);
  resetFileInput();
};

const isValidInputFiles = (files: File[]) => {
  if (props.accept === "image/*") {
    return files.every((file) => isValidImage(file.name));
  }
};

const getImageThumbnailUrl = (file: File, index: number) => {
  if (!thumbnailUrlList.value[index]) {
    thumbnailUrlList.value[index] = URL.createObjectURL(file);
  }

  return thumbnailUrlList.value[index];
};

const deleteFile = (index: number) => {
  URL.revokeObjectURL(thumbnailUrlList.value[index]);
  inputFileList.value.splice(index, 1);
  thumbnailUrlList.value.splice(index, 1);

  const deletedFileInfo = props.fileInfos?.[index];
  if (deletedFileInfo) {
    emit("onDeletedFile", deletedFileInfo, props.fileInputUid);
  }
  resetFileInput();
};

const getFileList = () => {
  return inputFileList.value;
};

const convertFileUrlToFile = async (imageUrl: string, fileName: string) => {
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  return new File([blob], fileName);
};

const setFileList = async (fileUrl: string, fileName: string) => {
  const file = await convertFileUrlToFile(fileUrl, fileName);
  inputFileList.value = [file];
};

const setDefaultFileList = () => {
  if (!props.fileInfos?.length) return;
  props.fileInfos.forEach(async (file) => {
    if (file.fileUrl) {
      if (props.editMode) {
        const result = await fileStore.downloadFile(file.fileUid ?? "");
        file.fileUrl = result.data ? URL.createObjectURL(result.data.file) : "";
      }
      setFileList(file.fileUrl, file.fileName ?? "");
    } else if (file.fileName) {
      // binary로 저장되어 fileUrl이 없는 경우 fileName으로만 File 객체 만든다.
      const fileData = new File([], file.fileName);
      inputFileList.value.push(fileData);
    }
  });
};

onMounted(() => {
  setDefaultFileList();
});

__expose({ getFileList });

const __returned__ = { props, emit, showErrorModal, fileStore, fileInput, inputFileList, thumbnailUrlList, resetFileInput, onAddedFiles, isValidInputFiles, getImageThumbnailUrl, deleteFile, getFileList, convertFileUrlToFile, setFileList, setDefaultFileList }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})